import React from "react"
export function MinusOutline(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 2a8 8 0 110 16 8 8 0 010-16zm0 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zm4 5.75v1.5H6v-1.5h8z"
        fill="currentColor"
      />
    </svg>
  )
}
